import { graphql } from "../gql";

export const testAuditRuleResultsQueryDoc = graphql(`
  query AuditTestResults($ruleId: String!, $first: Int, $after: Cursor) {
    auditTestResultsV2(
      ruleId: $ruleId
      args: { first: $first, after: $after }
    ) {
      totalCount
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      edges {
        cursor
        node {
          id
          status
          lineItem {
            batchClaimId
            platformItemId
            seedType
          }
          humanFinding {
            revCode
            denialCode
            units
            discrepantBilledAmount
            overcharge
            rationale
          }
          ruleFinding {
            revCode {
              value
              status
            }
            denialCode {
              value
              status
            }
            units {
              value
              status
            }
            discBilledAmount {
              value
              status
            }
            overcharge {
              value
              status
            }
            rationale
          }
        }
      }
    }
  }
`);

export const testAuditRuleResultsSummaryQueryDoc = graphql(`
  query auditTestResultsSummaryV2($ruleId: String!) {
    auditTestResultsSummaryV2(ruleId: $ruleId) {
      totalLineItems
      humanOnly
      bothRuleAndHuman
      ruleOnly
      fieldAccuracy {
        revCode {
          accuracy
          errors
          warnings
        }
        denialCode {
          accuracy
          errors
          warnings
        }
        discQty {
          accuracy
          errors
          warnings
        }
        savings {
          accuracy
          errors
          warnings
        }
      }
    }
  }
`);

export const testAuditRuleResultsCsvQueryDoc = graphql(`
  query auditTestResultsCsvV2($id: String!) {
    auditTestResultsCsvV2(id: $id)
  }
`);
